module.exports = __webpack_public_path__ + "media/assets/file_extension_pdf-0406f720d48adde3738673d3991371fdbed92e86e62f3fac9dc5baf02b3614f6.png";